import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'legal-dsa',
		path: '/policies/dsa',
		priority: 100, // to be matched before /policies/:slug
		component: loadable(async () => import(/* webpackChunkName: "pages/legal-dsa" */ './index'), {
			exportName: 'Dsa',
			fallback: Loading,
		}),
		frame: true,
		preventCookieWall: true,
		ssr: {
			enabled: true,
			seo: false, // page should not be indexable
			config: {
				disallowUserData: true,
				cache: {
					enabled: true,
					lifetimeInSeconds: 1 * 60 * 60, // 1 hour
				},
			},
		},
	},
];
